export const moduleNames = {

  // ADMIN MODULES
  ADMIN_HOME: 'adminHome',
  ADMIN_USERS: 'adminUsers',
  ADMIN_LOGIN_HISTORY: 'adminLoginHistory',
  ADMIN_PROFILE: 'adminProfile',
  ADMIN_FORMS_DROPDOWN: 'adminFormsDropdown',
  ADMIN_FORMS_TEMPLATES: 'adminFormsTemplates',
  ADMIN_FORMS_SUBMISSIONS: 'adminFormsSubmissions',
  ADMIN_WORKING_SITES: 'adminWorkingSites',
  ADMIN_WORKING_SITES_PLANNER: 'adminWorkingSitesPlanner',
  ADMIN_WORKING_HOURS: 'adminWorkingHours',
  ADMIN_EMPLOYEES: 'adminEmployees',
  ADMIN_EMPLOYEES_SINGLE: 'adminEmployeesSingle',
  ADMIN_COMMUNE: 'adminCommune',
  ADMIN_CANTONS: 'adminCantons',
  ADMIN_CANTONS_HOLIDAYS: 'adminCantonsHolidays',
  ADMIN_CITIES: 'adminCities',
  ADMIN_TAX_SCALES: 'adminTaxScales',
  ADMIN_TAX_SCALES_DETAILS: 'adminTaxScalesDetails',
  ADMIN_TAX_EMPLOYEES: 'adminTaxEmployees',
  ADMIN_WORKING_HOURS: 'adminWorkingHours',
  ADMIN_WORKING_HOURS_SUBMISSIONS: 'adminWorkingHoursSubmissions',
  ADMIN_WORKING_HOURS_TOTALS: 'adminWorkingHoursTotals',
  ADMIN_WORKING_HOURS_DROPDOWN: 'adminWorkingHoursDropdown',
  ADMIN_EMPLOYEES_ABSENCE: 'adminEmployeesAbsence',
  ADMIN_EMPLOYEES_NOTES: 'adminEmployeesNotes',
  ADMIN_GROUPS: 'adminGroups',
  ADMIN_REPORT: 'adminReportDropdown',
  ADMIN_REPORT_EMPLOYEES: 'adminReportEmployees',
  ADMIN_REPORT_WORKING_SITES: 'adminReportWorkingSites',
  ADMIN_REPORT_WORK_TABLE: 'adminReportWorkTable',
  ADMIN_SPREADSHEETS: 'adminSpreadsheets',
  ADMIN_COMPANIES: 'adminCompanies',
  PROFILE: 'profile',

  //SYSTEM MODULES
  LOGOUT: 'logout',

  //DEV MODULES
  DEV_BUILDER_DROPDOWN: 'devBuilderDropdown',
  DEV_BUILDER_MODULE: 'devModuleBuilder',
}